import { useDisclosure } from "@mantine/hooks"
import { Outlet, useLocation } from "react-router"
import Header from "@/components/navigation/Header"
import { useEffect } from "react"
import { client } from "@/hooks/useClient"

export default function BaseLayout() {
  const [opened] = useDisclosure()
  const location = useLocation()

  useEffect(() => {
    const slug = location.pathname.split("/")[1]
    if (slug) {
      client.defaults.headers.common["x-ws-slug"] = slug
    }
  }, [location.pathname])

  return (
    <div className="h-screen">
      <Header />
      <main className="size-full pt-[var(--header-height)]">
        {/* <div className="w-full overflow-hidden rounded-xl shadow-panel"> */}
          <Outlet />
        <footer className=""></footer>
      </main>
      <aside className=""></aside>
    </div>
    // <div className="grid h-screen grid-cols-[var(--sidebar-width)_1fr_var(--aside-width)] bg-ground-theme">
    //   <div>
    //     <nav className="fixed top-0 left-0 h-screen w-[var(--sidebar-width)]">
    //       <Sidenav />
    //     </nav>
    //   </div>
    //   <main className="grid h-screen w-full grid-rows-[var(--header-height)_1fr_var(--aside-width)]">
    //     <Header />
    //     {/* <div className="w-full overflow-hidden rounded-xl shadow-panel"> */}
    //     <div className="w-full overflow-hidden rounded-xl">
    //       <Outlet />
    //     </div>
    //     <footer className=""></footer>
    //   </main>
    //   <aside className=""></aside>
    // </div>
  )
}
